import type { PublicConfig } from "@shared/types";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export function usePublicConfig() {
	return useQuery({
		queryKey: queryKeys.config.public(),
		queryFn: async ({ signal }) => {
			return api.get<PublicConfig>("/api/v3/config/public", signal);
		},
		staleTime: 1000 * 60 * 30, // 30 minutes - rarely changes
		gcTime: 1000 * 60 * 60, // 1 hour
	});
}
